import React from 'react';
import { Link } from 'react-scroll';
import { HiChevronDown } from 'react-icons/hi';
import './Hero.css';

function Hero() {
  const bgImage = `${process.env.PUBLIC_URL}/images/miriam-headshot.png`;

  return (
    <section
      className="hero"
      id="hero"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="hero__overlay" />
      <div className="hero__content">
        {/* <p className="hero__preheading">CEO of ActionAI</p> */}
        <h1 className="hero__title">
          Ted Speaker, AI Founder,<br />
          <span className="hero__title-accent">Writer & Activist</span>
        </h1>
        <p className="hero__subtitle">
         Technologist. Activist. Speaker. From Stanford's youngest CS teacher to leading AI innovation in the Middle East.
        </p>
        <div className="hero__cta">
          <Link to="contact" smooth={true} duration={600} offset={-80} className="btn-primary">
            Get in Touch
          </Link>
        </div>
      </div>
      <Link to="about" smooth={true} duration={600} offset={-80} className="hero__scroll">
        <span>Scroll</span>
        <HiChevronDown />
      </Link>
    </section>
  );
}

export default Hero;
